// removed by extract-text-webpack-plugin
module.exports = {"user-inactivity-container":"user-inactivity-container","userInactivityContainer":"user-inactivity-container","btn-user-inactivity-cleanup-wrapper":"btn-user-inactivity-cleanup-wrapper","btnUserInactivityCleanupWrapper":"btn-user-inactivity-cleanup-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/generalSettings/styles.scss
// module id = 1414
// module chunks = 0